// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

// Place any jQuery/helper plugins in here.

// przykładowe odpalenie SweetAlert2
/*
Swal.fire({
    html: 'Czy chcesz zapisać się na wydarzenie <div><strong>' + clickedItem.data('foobar') + '?</strong></div>',
    showCancelButton: true,
    confirmButtonText: `Zapisz się`,
    cancelButtonText: `Anuluj`,
    customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-secondary'
    },
    buttonsStyling: false
}).then((result) => {
    if (result.isConfirmed) {
        // do sth
    }
})*/
